import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DeviceService } from "./_services/device.service";
import { isEmeniBackendUrl } from "./_helpers/isEmeniBackendUrl";

@Injectable()
export class DeviceIDInterceptor implements HttpInterceptor {

  constructor(private ds: DeviceService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Samo eMeni backend; JSONP ne podržava header-e, a "udid" ne treba slati trećim stranama.
    if (req.method === 'JSONP' || !isEmeniBackendUrl(req.url)) {
      return next.handle(req);
    }

    var newHeaders = req.headers.set("udid", this.ds.deviceID);
    var r = req.clone(
      {
        headers: newHeaders
      }
    );

    return next.handle(r);
  }

}
